/** Shared applicability option lists for policy wizards and salary structure assignment. */

export const POLICY_LOCATION_OPTIONS = [
  { value: "", label: "All Locations" },
  { value: "1", label: "Mumbai" },
  { value: "2", label: "Delhi" },
  { value: "3", label: "Bangalore" },
];

export const POLICY_EMPLOYMENT_TYPE_OPTIONS = [
  { value: "full_time", label: "Full-time" },
  { value: "contract", label: "Contract" },
  { value: "intern", label: "Intern" },
  { value: "consultant", label: "Consultant" },
  { value: "external", label: "External" },
  { value: "part_time", label: "Part-time" },
  { value: "trainee", label: "Trainee" },
];

export const APPLICABILITY_CLEAR_FIELDS = {
  branch: "",
  department: "",
  designation: "",
  grade: "",
  category: "",
  subDepartment: "",
  location: "",
};
